import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, Power, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

// Shared list actions: reorder (up/down), toggle active, delete with confirmation and friendly 409 handling.
export function ListActions({ item, index, rows, resource, isActive, onToggle, onChanged, testKey }) {
  const move = async (dir) => {
    const ids = rows.map((r) => r.id); const j = index + dir;
    if (j < 0 || j >= ids.length) return;
    [ids[index], ids[j]] = [ids[j], ids[index]];
    try { await api.post(`/${resource}/reorder`, { ids }); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const toggle = async () => {
    if (isActive && !window.confirm(`Inativar "${item.name}"? A opção deixa de aparecer para novas OS, mas o histórico é preservado.`)) return;
    try { await onToggle(item, !isActive); toast.success(isActive ? "Opção inativada" : "Opção reativada"); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async () => {
    if (!window.confirm(`Excluir "${item.name}" permanentemente? Esta ação não pode ser desfeita.`)) return;
    try { await api.delete(`/${resource}/${item.id}`); toast.success("Excluído com sucesso"); onChanged(); }
    catch (e) { toast.error(errMsg(e), { duration: 6000 }); }
  };
  return (
    <div className="flex items-center gap-1">
      <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => move(-1)} disabled={index === 0} data-testid={`up-${testKey}`} title="Mover para cima"><ArrowUp className="w-3.5 h-3.5" /></Button>
      <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => move(1)} disabled={index === rows.length - 1} data-testid={`down-${testKey}`} title="Mover para baixo"><ArrowDown className="w-3.5 h-3.5" /></Button>
      <Button size="icon" variant="ghost" className={`h-8 w-8 ${isActive ? "text-amber-600" : "text-emerald-600"}`} onClick={toggle} data-testid={`toggle-${testKey}`} title={isActive ? "Inativar" : "Reativar"}><Power className="w-3.5 h-3.5" /></Button>
      <Button size="icon" variant="ghost" className="h-8 w-8 text-rose-600" onClick={del} data-testid={`delete-${testKey}`} title="Excluir"><Trash2 className="w-3.5 h-3.5" /></Button>
    </div>
  );
}
